
export * from './channel-mask.js';
export * from './console-logger.js';
export * from './log-level.js';
export * from './logger.js';

import { Logger } from './logger.js';
import { isNullOrUndefined } from './null-safety.js';

const loggers: Logger[] = [];

export function initialize(initialLoggers: Logger[]): void {
  loggers.length = 0;

  loggers.push(...initialLoggers);
}

export function addLogger(logger: Logger): void {
  loggers.push(logger);
}

export function removeLogger(predicate: (logger: Logger) => boolean): void {
  for(let i = 0; i < loggers.length; ++i) {
    if(predicate(loggers[i])) {
      loggers.splice(i, 1);
      return;
    }
  }
}

export function clearLoggers(): void {
  loggers.length = 0;
}

function formatException(exception: unknown, stringify?: boolean): string | null {
  if(isNullOrUndefined(exception)) {
    return null;
  }

  if(stringify === true) {
    return JSON.stringify(exception, null, 2);
  }

  if(typeof exception === 'string') {
    return exception as string;
  }

  return (exception as object).toString();
}

export function logDebug(
    message: string,
    args?: {
    channel?: string,
  }
): void {
  for(const logger of loggers) {
    logger.logDebug(message, args);
  }
}

export function logInfo(
    message: string,
    args?: {
      channel?: string,
    }
): void {
  for(const logger of loggers) {
    logger.logInfo(message, args);
  }
}

export function logWarning(
    warning: string,
    args?: {
      channel?: string,
    }
): void {
  for(const logger of loggers) {
    logger.logWarning(warning, args);
  }
}

export function logError(
    error: string,
    exception?: unknown,
    args?: {
      channel?: string,
      stackTrace?: string,
      stringify?: boolean,
    }
): void {
  const formattedException = formatException(exception, args?.stringify);
  const errorMessage = isNullOrUndefined(formattedException) ? error : `${error}${formattedException}`;

  for(const logger of loggers) {
    logger.logError(errorMessage, args);
  }
}

export function logException(
    exception: unknown,
    args?: {
      channel?: string,
      stackTrace?: string,
      stringify?: boolean
    }
): void {
  const formattedException = formatException(exception, args?.stringify) ?? 'null';
  for(const logger of loggers) {
    logger.logException(formattedException, args);
  }
}

export function logFatal(
    exception: unknown,
    args?: {
      channel?: string,
      stackTrace?: string,
      stringify?: boolean
    }
): void {
  const formattedException = formatException(exception, args?.stringify) ?? 'null';
  for(const logger of loggers) {
    logger.logFatal(formattedException, args);
  }
}

